import { MessageFilled, MessageOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import { useGetMessageGroups } from "apps/CustomerPanel/Message/ServerSideStates";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MessageCount = () => {
  const navigate = useNavigate();

  const messageGroups = useGetMessageGroups({PageSize:-1});
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (messageGroups?.data?.data?.data) {
      let allList = messageGroups?.data?.data?.data || [];
      let allLength = 0;
      allList.forEach((item: any) => {
        allLength += item?.unreadMessageCount
      });
      setCount(allLength);
    }
  }, [messageGroups?.data]);
  return (
    <>
      <div
        onClick={() => {
          navigate(`/admin/panel?activePanelMenu=messages`);
        }}
      >
        {count ? (
          <>
            <Badge count={count}>
              <MessageFilled className="!text-xl hover:cursor-pointer !text-red-500 " />
            </Badge>
          </>
        ) : (
          <>
          <MessageOutlined className="!text-xl hover:cursor-pointer  " />
          </>
        )}
      </div>
    </>
  );
};

export default MessageCount;
